export default __webpack_public_path__ + "static/media/cn.ad707ae3.svg";